import {observable} from 'mobx';

class Store {
    @observable question = null;
    @observable questionCount = null;
    @observable info = null;
    @observable hasResult = false;
    @observable result = null;

    @observable modalShown = false;
    @observable modalType = null;

    addAssignment(assignment) {
        this.question = assignment.question;
        this.questionCount = assignment.questionCount;
        this.info = assignment.info;
        this.hasResult = assignment.hasResult;
    }

    showModal(modalType) {
        this.modalShown = true;
        this.modalType = modalType;
    }

    hideModal() {
        this.modalShown = false;
        this.modalType = null
    }

    handleResult(result) {
        this.result = result;
    }
}

export default new Store;


// WEBPACK FOOTER //
// ./src/store/store.js